import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getChipsGroupWidgetStyles = props => {
  var _tokens$spacing = tokens.spacing,
    SPACING_0 = _tokens$spacing.SPACING_0,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_20 = _tokens$spacing.SPACING_20,
    SPACING_40 = _tokens$spacing.SPACING_40;
  var _props$numOfColumns = props.numOfColumns,
    numOfColumns = _props$numOfColumns === void 0 ? 2 : _props$numOfColumns;
  return StyleSheet.create({
    mainContainer: {
      paddingTop: SPACING_8
    },
    badge: {
      width: '100%',
      height: SPACING_40
    },
    chipsContainer: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start'
    },
    chip: {
      width: 100 / numOfColumns + "%",
      paddingRight: SPACING_12,
      paddingBottom: SPACING_12,
      alignItems: 'center'
    },
    lastChip: {
      paddingRight: SPACING_0
    },
    lastRow: {
      paddingBottom: SPACING_0
    },
    buttonContainer: {
      marginTop: SPACING_20
    },
    calloutContainer: {
      marginBottom: SPACING_20
    }
  });
};